<!-- H5关联文件 -->
<template lang="pug">
van-popup(v-model="popupShow" position="bottom" closeable :overlay="false" @closed="close")
  .associateFile
    .titleRow 关联文件
    .content
      van-search(v-model="keyword" placeholder="请输入搜索关键词" clearable @input="toRefresh")
      template(v-if="!keyword")
        //- 面包屑
        ul.breadcrumb
          li(v-for="(item, index) in navList" :key="index" :class="{ 'navActive': item.folderId === currentFolderId }" @click="clickBread(item, index)") {{ item.folderName }}
            span(v-if="index !== navList.length - 1" style="padding: 0px 6px") /
        //- 文档列表
        van-pull-refresh.folderList(v-model="refreshing" v-loading="loading" @refresh="onRefresh")
          .folderItem(v-for="item in myDocList" :key="item.folderId" :class="{ 'folderActive': item.isSelected }" @click="nextDetails(item)")
            van-image.leftIcon(fit="contain" :src="logoSrc(item)" @click.stop="select(item)")
            .folder_name
              .file {{ item.folderName }}
              .date {{ item.checkInDate || item.operDate }}
          .empty(v-if="!myDocList.length") 暂无数据
      //- 搜素列表
      template(v-if="keyword")
        search(ref="search" :keyword="keyword" :prjId="prjId" @intoFolder="intoFolder" )
      .buttons
        van-button.button(type="info" round plain @click="popupShow = false") 取消
        van-button.button(type="info" round :loading="btnLoading" @click="submit") 确定
</template>

<script>
import { mapState } from "vuex";
import { throttle } from "@/CommonDP/utils/throttle.js"; // 函数节流
import { tableRowIcon } from "@/CommonDP/utils/docPublic";
import docService from "@/CommonDP/service/doc-service";
import search from "./search.vue";

export default {
  components: { search },
  data() {
    return {
      prjId: "",
      popupShow: false,
      navList: [], // 展开路径
      currentFolderId: "", // 当前打开的文件夹id
      // 请求参数
      argument: {
        isRead: 1,
        priviAll: "1",
        noRightClickMenu: true,
        versionId: ""
      },
      keyword: "", // 搜索关键字
      myDocList: [], // 文档列表
      refreshing: false,
      loading: false,
      btnLoading: false
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  mounted() {},
  methods: {
    // logo图片地址
    logoSrc(item) {
      return tableRowIcon(item);
    },
    // 打开事件
    open(prjId) {
      this.popupShow = true;
      this.init(prjId);
    },
    // 初始化
    init(prjId) {
      this.prjId = prjId;
      const folderId = 0;
      // 设置展开路径
      const rootNav = { folderId, folderName: "文档" };
      this.navList.push(rootNav);
      this.getMyDocList(folderId);
    },
    // 获得文档列表
    async getMyDocList(folderId) {
      this.loading = true;
      try {
        const prjId = this.prjId;
        const params = { ...this.argument, prjId, folderId };
        const { data } = await docService.queryTree(params);
        const list = data?.filter(({ folderId }) => folderId !== "recycle").map(item => {
          const { childFolder = 0 } = item;
          return {
            ...item,
            leaf: childFolder === 0
          };
        });
        this.myDocList = list || [];
        this.currentFolderId = folderId;
      } finally {
        this.loading = false;
      }
    },

    // 刷新列表
    toRefresh() {
      this.getMyDocList(this.currentFolderId);
    },
    // 点击路径
    clickBread(item, index) {
      this.navList = this.navList.slice(0, index + 1);
      this.getMyDocList(item.folderId);
    },
    // 下拉刷新
    async onRefresh() {
      try {
        const folderId = this.currentFolderId;
        await this.getMyDocList(folderId);
      } finally {
        this.refreshing = false;
      }
    },
    // 点击文件夹，进入下一级
    nextDetails: throttle(function (item) {
      if (item.isFolder === 1) {
        this.navList.push(item);
        this.getMyDocList(item.folderId);
      } else {
        this.select(item);
      }
    }, 200),
    // 进入定位的文件夹(路径)
    intoFolder(navList) {
      if (navList) {
        this.keyword = "";
        this.navList = [...navList];
        const lastNav = navList[navList.length - 1];
        this.getMyDocList(lastNav.folderId);
      }
    },

    // 选中
    select(item) {
      if (item.isSelected) this.$set(item, "isSelected", false);
      else this.$set(item, "isSelected", true);
    },
    // 获得选中列表
    getCheckedList() {
      const selectedList = this.myDocList.filter((e) => e.isSelected);
      return selectedList || [];
    },

    // 关闭事件
    close() {
      this.myDocList = [];
      this.navList = [];
      this.currentFolderId = "";
      this.keyword = "";
    },
    // 确定
    async submit() {
      this.btnLoading = true;
      try {
        let list = [];
        if (this.keyword) list = this.$refs.search.getCheckedList();
        else list = this.getCheckedList();
        // 对于直接选择文件可以先拿出来
        const array = list.filter(({ isFolder }) => isFolder === 0);
        const arrayFolder = list.filter(({ isFolder }) => isFolder === 1);
        const backList1 = array.map((item) => {
          return {
            fileId: item.folderId,
            fileName: item.folderName,
            fileType: item.fileType,
            isFolder: item.isFolder,
            uploadType: 1
          };
        });
        const backList2 = [];
        // 选中的文件夹点击确定获取子级数据
        for (const item of arrayFolder) {
          const params = {
            prjId: this.prjId,
            folderId: item.folderId,
            keyWord: ""
          };
          const { data } = await docService.querySearchFolder(params);
          let listData = data.map((item) => {
            return {
              fileId: item.folderId,
              fileName: item.folderName,
              fileType: item.fileType,
              isFolder: item.isFolder,
              uploadType: 1
            };
          });
          listData = listData.filter(({ isFolder }) => isFolder === 0);
          backList2.push.apply(backList2, listData);
        }
        // 拼接原来选择的文件
        const backList = backList1.concat(backList2);
        this.$emit("callback", backList);
        this.popupShow = false;
      } finally {
        this.btnLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.associateFile {
  width: 100vw;
  height: 100vh;
  position: relative;
  .titleRow {
    height: 46px;
    padding: 0 10px;
    line-height: 46px;
    border-bottom: 1px solid #f5f6fa;
    text-align: center;
  }
  .content {
    height: calc(100% - 46px);
    padding-top: 5px;
    background-color: #f5f6fa;
    display: flex;
    flex-direction: column;
    .buttons {
      padding: 2vh 0;
      background-color: #fff;
      text-align: center;
      .button {
        width: 200px;
        height: 40px;
        margin: 0 4vw;
        max-width: 42vw;
      }
    }
  }
}

.breadcrumb {
  width: 100%;
  height: 32px;
  line-height: 32px;
  padding: 0 16px;
  white-space: nowrap;
  background-color: #ffffff;
  border-bottom: 1px solid #e5e8f1;
  overflow: auto;

  li {
    list-style: none;
    display: inline-block;
    color: var(--theme-color, #4777e7);
    font-size: 14px;
  }
  .navActive {
    color: #323232;
  }
}

.folderList {
  width: 100%;
  height: 1px;
  flex-grow: 1;
  overflow-y: auto;
  .empty {
    width: 100%;
    height: calc(100% - 66px);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999999;
    font-size: 16px;
  }
}

.folderItem {
  width: 100%;
  height: 70px;
  padding: 0 3vw;
  box-sizing: border-box;
  background-color: #ffffff;
  border-bottom: 1px solid #e5e8f1;
  display: flex;
  align-items: center;

  .leftIcon {
    width: 42px;
    height: 42px;
    padding: 5px;
    margin-bottom: 2px;
  }

  .folder_name {
    width: calc(100% - 75px);
    height: 50px;
    overflow-x: overlay !important;
    overflow-x: auto;

    .file {
      font-size: 16px;
      line-height: 20px;
      color: #323232;
      white-space: nowrap;
      margin-top: 6px;
    }
    .date {
      font-size: 13px;
      line-height: 16px;
      color: #999999;
      white-space: nowrap;
    }
  }

  .rightIcon {
    padding: 6px;
    font-size: 18px;
  }
}
.folderActive {
  background-color: #7fc65c;
  .file,
  .date {
    color: #fff !important;
  }
}

::v-deep .van-popup__close-icon--top-right {
  top: 12px;
  right: 12px;
}
</style>
